import { Link } from '@tanstack/react-router'
import { Button } from '@/components/ui/button'
import { useTranslation } from 'react-i18next'
import { Home, LifeBuoy } from 'lucide-react'
import { useLang } from '@/hooks/useLang'

export function NotFoundContent() {
  const { t } = useTranslation('common')
  const lang = useLang()

  return (
    <div className="flex flex-col items-center justify-center py-24">
      <div className="container mx-auto px-4">
        <div className="max-w-2xl mx-auto text-center space-y-8">
          <div className="inline-flex items-center justify-center rounded-full bg-primary/10 text-primary px-4 py-2 font-semibold">
            404
          </div>
          <div className="space-y-4">
            <h1 className="text-4xl font-bold text-foreground md:text-5xl">
              {t('errors.notFoundTitle')}
            </h1>
            <p className="text-lg text-muted-foreground">
              {t('errors.notFoundDescription')}
            </p>
          </div>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-4">
            <Button size="lg" asChild>
              <Link to="/$lang" params={{ lang }}>
                <Home className="w-4 h-4 mr-2" />
                {t('errors.goHome')}
              </Link>
            </Button>
            <Button size="lg" variant="outline" asChild>
              <a href="mailto:support@phonesalad.com">
                <LifeBuoy className="w-4 h-4 mr-2" />
                {t('errors.contactSupport')}
              </a>
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
